import { useTranslation } from 'react-i18next';

export default function BeforeAfter() {
  const { t } = useTranslation();

  const examples = [
    {
      type: t('landing.ba.type1', { defaultValue: 'Instagram Bio' }),
      before: t('landing.ba.b1', { defaultValue: 'Fashion lover 🌸 | NYC based | DM for collabs | Link in bio ↓' }),
      after: t('landing.ba.a1', { defaultValue: '✦ Fashion editor turned creator\nCurating effortless style for the modern woman\n📍 NYC | Collabs → hello@sophia.co\n↓ Shop my curated picks' }),
    },
    {
      type: t('landing.ba.type2', { defaultValue: 'Post Caption' }),
      before: t('landing.ba.b2', { defaultValue: 'New post! Really loving this outfit today. What do you think? Comment below! #fashion #ootd #style #love #instagood' }),
      after: t('landing.ba.a2', { defaultValue: 'Soft mornings, slower Sundays.\n\nThis look is everything I needed this season — minimal but intentional. Save this for your next weekend edit ✦\n\n#SlowFashion #StyleEdit #WeekendMood' }),
    },
    {
      type: t('landing.ba.type3', { defaultValue: 'Hashtag Set' }),
      before: t('landing.ba.b3', { defaultValue: '#fashion #style #love #instagood #photooftheday #beautiful #happy #cute #instadaily #followme' }),
      after: t('landing.ba.a3', { defaultValue: '#SlowFashion #StyleEdit #MinimalOutfit #CuratedWardrobe #OOTD #FashionCreator #PersonalStyle #ModernElegance #WardrobeEssentials #StyleInspo' }),
    },
  ];

  return (
    <section id="before-after" className="ba-section">
      <div className="section-label">
        {t('landing.ba.label', { defaultValue: 'Before & After' })}
      </div>
      <h2 className="section-title">
        {t('landing.ba.title1', { defaultValue: 'See the ' })}
        <em>{t('landing.ba.title2', { defaultValue: 'difference' })}</em>
        {t('landing.ba.title3', { defaultValue: ' AI makes' })}
      </h2>
      <p className="section-sub">
        {t('landing.ba.sub', { defaultValue: 'Generic copy vs. CaptionScript — same niche, completely different impact.' })}
      </p>

      <div className="ba-grid">
        {examples.map((ex, i) => (
          <div key={i} className="ba-card">
            <div className="ba-type">{ex.type}</div>
            <div className="ba-columns">
              <div className="ba-col ba-before">
                <div className="ba-col-label">
                  {t('landing.ba.beforeLabel', { defaultValue: 'Before' })}
                </div>
                <div className="ba-text">{ex.before}</div>
              </div>
              <div className="ba-arrow">→</div>
              <div className="ba-col ba-after">
                <div className="ba-col-label">
                  {t('landing.ba.afterLabel', { defaultValue: 'After' })}
                  <span style={{ marginLeft: '8px', fontSize: '0.65rem', background: 'var(--gold)', color: '#000', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>{t('landing.ba.premiumBadge', { defaultValue: 'PREMIUM' })}</span>
                </div>
                <div className="ba-text">{ex.after}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
